// extracted by mini-css-extract-plugin
export var filterIncDec = "_3x-0";
export var leftBorder = "_3x-1";
export var rightBorder = "_3x-2";
export var stringInput = "_3x-3";